// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1a-Jk","fullView":"styles_fullView__2PsXb"};